export function exportToCSV(filename, rows, columns) {
  const header = columns.map(c => `"${c.label}"`).join(',');
  const body = rows.map(row =>
    columns.map(c => `"${String(row[c.key] ?? '').replace(/"/g, '""')}"`).join(',')
  ).join('\n');
  const blob = new Blob([header + '\n' + body], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function printTable(title, subtitle, columns, rows) {
  const headerRow = columns.map(c => `<th style="padding:6px 10px;border:1px solid #e2e8f0;background:#1e3a5f;color:#fff;font-size:12px;text-align:left;">${c.label}</th>`).join('');
  const bodyRows = rows.map(row =>
    `<tr>${columns.map(c => `<td style="padding:6px 10px;border:1px solid #e2e8f0;font-size:12px;">${row[c.key] ?? ''}</td>`).join('')}</tr>`
  ).join('');
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${title}</title>
    <style>@page{size:letter landscape;margin:0.5in}body{font-family:Arial,sans-serif;margin:0}table{width:100%;border-collapse:collapse}@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}</style>
    </head><body>
    <div style="display:flex;justify-content:space-between;align-items:baseline;padding-bottom:8px;border-bottom:2px solid #1e3a5f;margin-bottom:12px;">
      <span style="font-size:18px;font-weight:700;color:#1e3a5f;">RAIDER DEPOT — ${title}</span>
      <span style="font-size:12px;color:#64748b;">${subtitle}</span>
    </div>
    <table><thead><tr>${headerRow}</tr></thead><tbody>${bodyRows}</tbody></table>
    <div style="margin-top:12px;font-size:11px;color:#94a3b8;">Printed ${new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit'})}</div>
    </body></html>`;
  const win = window.open('', '_blank');
  if (!win) return;
  win.document.write(html);
  win.document.close();
  win.onload = () => win.print();
}
